import {Injectable} from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
    providedIn: 'root'
})
export class ExcelService {

    constructor() {
    }

    public exportAsExcelFile(data: any[], excelFileName: string, columns: any[]): void {
        const dataToExport = [];

        for (const record of data) {
            const model = {};
            for (const column of columns) {
                model[column.value] = record[column.key];
            }
            dataToExport.push(model);
        }

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook: XLSX.WorkBook = {Sheets: {data: worksheet}, SheetNames: ['data']};
        const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    public exportAsCustomExcelFile(data: any, excelFileName: string, columns: any[], custom?: boolean): void {
        const dataToExport = [];
        if (!custom) {
            data.forEach(record => {
                const model = {};

                for (const column of columns) {
                    model[column.label] = record[column.key];
                }
                dataToExport.push(model);
            });
        } else {
            data.forEach(record => {
                const model = {};

                for (const [i, column] of columns.entries()) {
                    const keys = Object.keys( record );
                    console.log(keys);
                    model[column.label] = keys[i];
                }
                dataToExport.push(model);
            });
        }

        const columnsNumber = columns.length;
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
        // const merge = [];
        // for (let i = 0; i < columnsNumber; i++) {
        //     const model = {
        //         s: {
        //             r: 0, c: i
        //         }, e: {
        //             r: 1, c: i
        //         }
        //     };
        //     merge.push(model);
        // }
        //
        // // const merge = [
        // //     { s: { r: 0, c: 0 }, e: { r: 2, c: columnsNumber - 1 } }
        // // ];
        // worksheet['!merges'] = merge;
        const workbook: XLSX.WorkBook = {Sheets: {data: worksheet}, SheetNames: ['data']};
        const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
        this.saveAsExcelFile(excelBuffer, excelFileName);
        // this.saveAsExcelFile(excelBuffer, excelFileName);
    }


    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
        FileSaver.saveAs(data, fileName + '-' + new Date().getTime() + EXCEL_EXTENSION);
    }
}
